import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name school
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtNCA2IDgtNCA4IDQiIC8+CiAgPHBhdGggZD0ibTE4IDEwIDQgMnY4YTIgMiAwIDAgMS0yIDJINGEyIDIgMCAwIDEtMi0ydi04bDQtMiIgLz4KICA8cGF0aCBkPSJNMTQgMjJ2LTRhMiAyIDAgMCAwLTItMnYwYTIgMiAwIDAgMC0yIDJ2NCIgLz4KICA8cGF0aCBkPSJNMTggNXYxNyIgLz4KICA8cGF0aCBkPSJNNiA1djE3IiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iOSIgcj0iMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/school
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const School: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm4 6 8-4 8 4' }],
    ['path', { d: 'm18 10 4 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8l4-2' }],
    ['path', { d: 'M14 22v-4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v4' }],
    ['path', { d: 'M18 5v17' }],
    ['path', { d: 'M6 5v17' }],
    ['circle', { cx: '12', cy: '9', r: '2' }],
  ],
];

export default School;
